import { Route } from 'react-router-dom';
import Settings from '../../components/pageComponents/Settings';
import HQSettings from '../../components/pageComponents/HQSettings';
import ProviderAgreementPage from '../../pages/settings/ProviderAgreement.tsx';

export const getSettingsRoutes = () => {
  const pages = [
    {
      path: '/settings',
      Component: Settings,
    },
    {
      path: '/op-settings',
      Component: HQSettings,
    },
    {
      path: '/open-dr-settings',
      Component: HQSettings,
    },
    {
      path: '/settings/agreement',
      Component: ProviderAgreementPage,
    },
  ];

  return pages.map((route) => {
    const { path, Component } = route;
    return <Route key={path} path={path} element={<Component />} />;
  });
};
